module.exports = __webpack_public_path__ + "img/249.6c401cda.png";